import { Injectable, EventEmitter } from '@angular/core';
import { SignalRService, SignalREventService, Language, LanguageDetail, DataArray } from './../index';

@Injectable()
export class LanguageService {
    public lagnuagesChange: EventEmitter<Language[]> = new EventEmitter<Language[]>();
    public languageDetailChange: EventEmitter<LanguageDetail> = new EventEmitter<LanguageDetail>();
    public languages: DataArray<Language> = new DataArray<Language>();

    constructor(
        private _signalRService: SignalRService,
        private _signalREventService: SignalREventService
    ) {
        this.registerOnServerEvents();
    }

    public getSections(): void {
        this._signalRService.invoke('GetLanguages');
    }

    private onLanguages(info: any): void {
        this.languages.init();

        for (const item of info.Data.Languages) {
            const language: Language = $.extend(new Language(), item);
            this._signalRService.invoke('GetLanguagePackInfo', language.Part);
            this.languages.push(language);
        }

        this.lagnuagesChange.emit(this.languages.Data);
    }

    private onLanguageDetail(info: any): void {
        const language: Language = this.languages.Data.filter((value) => value.Part == info.Data.Pack)[0];
        language.Detail = info.Data.Details;

        this.languageDetailChange.emit(language.Detail);
    }

    private registerOnServerEvents() {
        this._signalREventService.register('LanguageService', 'languages', (info: any) => this.onLanguages(info));
        this._signalREventService.register('LanguageService', 'languageDetails', (info: any) => this.onLanguageDetail(info));
    }


    public deregisterOnServerEvents(): void {
        this._signalREventService.deregister('LanguageService');
    }
}
